
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './types';

interface ContactMethodFieldProps {
  form: UseFormReturn<FormValues>;
}

export const ContactMethodField: React.FC<ContactMethodFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="contactMethod"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Preferred Contact Method</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select contact method" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="Email">Email</SelectItem>
              <SelectItem value="Phone">Phone</SelectItem>
              <SelectItem value="Either is fine">Either is fine</SelectItem>
              <SelectItem value="No need to contact me">No need to contact me</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
